import * as schedule from './schedule'

export default schedule
